import { Moon, Sun } from "@phosphor-icons/react";
import { useEffect } from "react";
import { themeChange } from "theme-change";

export const ColorModeToggle: React.FC = () => {
  useEffect(() => {
    themeChange(false);
  }, []);
  return (
    <button data-toggle-theme="dark,knoword">
      <span>
        <span className="before:content-['Dark'] dark:before:content-['Light']" />{" "}
        mode
      </span>
      <span />
      <div className="swap swap-rotate dark:swap-active">
        <Moon className="swap-on size-4" weight="bold" />
        <Sun className="swap-off size-4" weight="bold" />
      </div>
    </button>
  );
};
